/**
 * @param color - color in HEX or RGB formats
 * @param alpha - alpha in percentage [0;1]
 */
export function getRGBA(color: string, alpha: number) {
  const rgb = color[0] === "#" ? hexToRgb(color) : color;

  const [r, g, b] = rgb.replace(/[^\d,]/g, "").split(",");

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function hexToRgb(hex: string) {
  const bigint = Number.parseInt(hex.slice(1), 16);

  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgb(${r}, ${g}, ${b})`;
}
